import { jsx } from 'react/jsx-runtime';
import * as Sentry from '@sentry/browser';
import { createContext, useEffect, useMemo, useContext } from 'react';
import { setupSentry } from '../helpers/monitoring.esm.js';

/* istanbul ignore next */ var DEFAULT_MONITORING_CONTEXT_VALUE = {
    reportException: function(_exception, _props) {}
};
/* istanbul ignore next */ var MonitoringContext = /*#__PURE__*/ createContext(DEFAULT_MONITORING_CONTEXT_VALUE);
var MonitoringProvider = function(param) {
    var monitoring = param.monitoring, user = param.user, children = param.children;
    useEffect(function() {
        setupSentry(monitoring.sentry, user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var value = useMemo(function() {
        return {
            reportException: function(error, param) {
                var tags = param.tags, extra = param.extra;
                Sentry.captureException(error, {
                    tags: tags,
                    extra: extra
                });
            }
        };
    }, []);
    return /*#__PURE__*/ jsx(MonitoringContext.Provider, {
        value: value,
        children: children
    });
};
function useMonitoringContext() {
    return useContext(MonitoringContext);
}

export { DEFAULT_MONITORING_CONTEXT_VALUE, MonitoringContext, MonitoringProvider, useMonitoringContext };
